import React, { useEffect } from 'react';
import strs from './strings';
import { Spacer, DragNDrop, EmptyElement, BackButton, PageNotFound, Spacer100, Spacer10, Spacer25 } from './Utils';
import logo from './imgs/continentalis-isotipo.png';
import { createBrowserRouter, RouterProvider, useNavigate, Link, useLocation, useSearchParams } from 'react-router-dom';
import Button from '@mui/material/Button';

import { useAuth } from './context';
import { signInWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { Typography } from '@mui/material';
import { deleteFirestoreDoc, getUser, setFirestoreDoc } from './firestore';
import { auth, provider } from './firebase';
import { fontWeight } from '@mui/system';

const lang = strs.en;

export function ComingSoon() {
	return (
	<div className='full-height flex-column-horizontal-center-only'>
		<Spacer100 />
		<div className='grid-column'>
			<center>
			<Spacer100 />
			<h1 className='primary-title-center slide-in-horizontally' style={{ fontSize: '48', fontWeight: '500'}}>{lang.comingSoon}</h1>
			</center>
			<Spacer100 />
			<div className='center-flex animated-div'>
				<img className='logo-login' alt="logo" src={logo}/>
			</div>
			<Spacer100 />
			<h1 className='primary-title-center slide-in-horizontally '>{lang.continentalisExpress}</h1>
			<Spacer />
			<p className='p larger-text centered-text'>{lang.appDescription}</p>
		</div>
		<Spacer />
	</div>
	);
}


export function LoginPage() {
	const navigate = useNavigate();
	const [formData, setFormData] = React.useState({
		email: "",
		password: "",
	});
	const [isVisible, setIsVisible] = React.useState('hidden');
	const [alertString, setAlertString] = React.useState('');
	const {login, signInWithGoogle} = useAuth();

	function validateEmail(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	function showAlert() {
		setIsVisible('fade-in');
		setTimeout( () => {
			setIsVisible('');
			setTimeout( () => {
				setIsVisible('fade-out');
			}, 1500);
			
		}, 500);
	}

	function showAlert() {
			setIsVisible('fade-in');
			setTimeout( () => {
				setIsVisible('');
				setTimeout( () => {
					setIsVisible('fade-out');
				}, 3000);
				
			}, 500);
	}


	function handleChange(event) {
		const {name, value, type} = event.target;
		setFormData( prevFormData => ({
			...prevFormData,
			[name]: value,
		}) );
// 		console.log(formData);
	}


	function handleKeydown(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleSubmit(event);
		}
	}

	async function handleSubmit(event) {
		console.log('handleSubmit')	
		if (formData.password === "" || formData.confirmPassword === "") {
			event.preventDefault()
			setAlertString(lang.noPassword);
			showAlert();
		}
		else if (!validateEmail(formData.email)) {
			event.preventDefault()
			setAlertString(lang.enterValidEmail);
			showAlert();
		}
		else {
			try {
				const userCredential = await login(formData.email, formData.password);
				const user = userCredential.user;
				navigate('/');
			}
			catch {
				setAlertString(lang.wrongCredentials)
				showAlert();
				console.log("Error logging into account.");
			}

		}
	}

	async function loginWithGoogle(event) {
		event.preventDefault();
		try {
			const userCredential = await signInWithGoogle();
			const user = userCredential.user;
			const uid = user.uid;
			const userData = {
				email: user.email,
				openedCases: [],
				caseList: [],
				resolvedCases: [],
			}
			console.log('userCredential', userCredential);
			console.log('user', user);

			try {
				const checkUser = await getUser();
				if (checkUser === undefined) {
					//create new user in database
					await setFirestoreDoc(`/users/${uid}`, userData);
					await setFirestoreDoc(`/documents/${uid}`, {docs: []});
				}
				navigate('/');
			}
			catch (error) {
				console.log('Trouble fetching user from database. Please check internet connection.');	
			}

		}
		catch {
			console.log("Error logging into account.");
		}
	}

	return (
	<div className='full-height flex-column-horizontal-center-only'>
		<Spacer100 />
		<div className='grid-column'>
			<center>
			<h1 className='primary-title-center slide-in-horizontally '>{lang.loginMessage}</h1>
			</center>
			<Spacer />
			<div className='center-flex animated-div'>
				<img className='logo-login' alt="logo" src={logo}/>
			</div>
		</div>
		<Spacer />
		<form className='login-form animated-div' onKeyDown={handleKeydown}>
			<input className='form-text-item' 
				type="text"
				placeholder={lang.email}
				onChange={handleChange}
				name="email"
				value={formData.email}
			/>

		<Spacer25 />
			<input className='form-text-item' 
				type="password"
				placeholder={lang.password}
				onChange={handleChange}
				name="password"
				value={formData.password}
			/>

			<div className={`${isVisible} little-popup alert`}>{alertString}</div>
			<Button
				onClick={() => navigate('/forgot-password')}
				className='grow-and-shrink-slightly'
				sx ={{
					fontSize: 16,
					fontFamily: 'inherit',
					fontWeight: 400,
					textTransform: 'none',
					borderRadius: 5,
				}}>
				{lang.forgotPassword}
			</Button>
			<Spacer25 />
			<Button 
				onClick={(event) => handleSubmit(event)}
				variant="contained" 
				className='grow-and-shrink-slightly' 
				sx={{
					minHeight:  40,
					minWidth: 200,
					borderRadius: 5,
					padding: 2,
					fontSize: 20,
					textTransform: "none",
					fontFamily: "inherit",
					fontWeight: 400,
			}}>
				{lang.login}
			</Button>
			<Spacer />
			<button style={{border: 'none'}} onClick={(event) => loginWithGoogle(event)}>
				<img src='/sign-in-with-google.svg' />
			</button>
			<Spacer />
			<p className='p'>{lang.noAccount}</p>
			<Spacer25 />
			<Button
				onClick={() => navigate('/sign-up')}
				className='grow-and-shrink-slightly'
				sx ={{
					fontSize: 20,
					fontFamily: 'inherit',
					fontWeight: 400,
					textTransform: 'none',
					borderRadius: 5,
					padding: 2,
				}}>
				{lang.signUp}
			</Button>

			<Spacer25 />
		</form>
	</div>
	);
}

export function ForgotPassword() {

	const navigate = useNavigate();
	const [formData, setFormData] = React.useState({
		email: "",
		password: "",
	});
	const [isVisible, setIsVisible] = React.useState('hidden');
	const [alertString, setAlertString] = React.useState('');
	//controls whether alert is blue (good) or red.
	const [goodAlert, setGoodAlert] = React.useState('alert');
	const {resetPassword} = useAuth();


	function handleKeydown(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleSubmit(event);
		}
	}


	function validateEmail(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	function showAlert() {
		setIsVisible('fade-in');
		setTimeout( () => {
			setIsVisible('');
			setTimeout( () => {
				setIsVisible('fade-out');
			}, 1500);
			
		}, 500);

		//We change the color of the alert back to red here.
		//If the alert was red to begin with no harm done.
		//If it wasn't as this doesn't go off for 2500 millisecond the original alert will have already faded 
		setTimeout( () => {
			setTimeout( () => {
				setGoodAlert('alert');
			}, 2000);
			
		}, 500);

	}


	function handleChange(event) {
		const {name, value, type} = event.target;
		setFormData( prevFormData => ({
			...prevFormData,
			[name]: value,
		}) );
// 		console.log(formData);
	}



	async function handleSubmit(event) {
		event.preventDefault()
		console.log(formData)
		if (!validateEmail(formData.email)) {
			setAlertString(lang.enterValidEmail);
			showAlert();
		}
		else {
			try {
				setGoodAlert('');
				await resetPassword(formData.email);
				setAlertString(lang.resetEmailSent);
				showAlert();
			}
			catch {
				console.log("Error sending password reset email.");
			}

		}

	}


	return (
	<div style={{margin: '0px 5%'}}>
		<Spacer />
		<BackButton />
	<div className='full-height flex-column-horizontal-center-only'>
		<Spacer100 />
		<h1 className='primary-title-center slide-in-horizontally centered-text'>{lang.passwordRecovery}</h1>
		<Spacer />
		<div className='grid-column'>
			<div className='center-flex animated-div'>
				<img className='logo-login' alt="logo" src={logo}/>
			</div>
		</div>


		<Spacer />
		<form className='login-form animated-div' onKeyDown={handleKeydown}>
			<input className='form-text-item' 
				type="text"
				placeholder={lang.email}
				onChange={handleChange}
				name="email"
				value={formData.email}
			/>

			<Spacer />
			<Button 
				onClick={(event) => handleSubmit(event)}
				variant="contained" 
				className='grow-and-shrink-slightly' 
				sx={{
					minHeight:  40,
					minWidth: 200,
					borderRadius: 5,
					padding: 2,
					fontSize: 20,
					textTransform: "none",
					fontFamily: "inherit",
					fontWeight: 400,
			}}>
				{lang.sendResetEmail}
			</Button>

			<Spacer25 />
			<Button
				onClick={() => navigate('/login')}
				className='grow-and-shrink-slightly'
				sx ={{
					fontSize: 20,
					fontFamily: 'inherit',
					fontWeight: 400,
					textTransform: 'none',
					borderRadius: 5,
					padding: 2,
				}}>
				{lang.login}
			</Button>

			<div className={`${isVisible} little-popup ${goodAlert}`}>{alertString}</div>
		</form>
	</div>
	</div>
	);

}

export function SignUp() {
	const navigate = useNavigate();
	const { signup } = useAuth();
	const [formData, setFormData] = React.useState({
		email: "",
		password: "",
		confirmPassword: "",
	});
	const [isVisible, setIsVisible] = React.useState('hidden');
	const [alertString, setAlertString] = React.useState('');

	function handleChange(event) {
		const {name, value, type} = event.target;
		setFormData( prevFormData => ({
			...prevFormData,
			[name]: value,
		}) );
	}

	function handleKeydown(event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleSubmit(event);
		}
	}


	async function handleSubmit(event) {
		console.log(formData)
		event.preventDefault()

		if (formData.password === "" || formData.confirmPassword === "") {
			setAlertString(lang.noPassword);
			showAlert();
		}
		else if (!validateEmail(formData.email)) {
				setAlertString(lang.enterValidEmail);
				showAlert();
		}
		else if (formData.password.length < 8) {
			setAlertString(lang.passwordTooShort);
			showAlert();
		}
		else if (formData.password === formData.confirmPassword) {
			try {
				const userCredential = await signup(formData.email, formData.password);
				const user = userCredential.user;
				const uid = user.uid;
				const userData = {
					email: user.email,
					availCases: 0,
					openedCases: [],
					caseList: [],
					resolvedCases: [],
				}

				console.log('userCredential', userCredential);
				console.log('user', user);
				
				let r = await setFirestoreDoc(`/users/${uid}`, userData);
				if (r.error) throw new Error('failed to write to users');
				r = await setFirestoreDoc(`/documents/${uid}`, {docs: []});
				if (r.error) {
					//Just undo the previous write which, if we are here, succeeded
					deleteFirestoreDoc(`/users/${uid}`)
					throw new Error('failed to write to documents');
				}
				navigate('/tos-dialog');
			}
			catch {
				console.log("Error signing up for new account.");
				setAlertString(lang.failedAccountCreate);
				showAlert();
			}
		}
		else {
			setAlertString(lang.passwordsDontMatch);
			showAlert();
		}

	}

	function validateEmail(email) {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	}

	function showAlert() {
			setIsVisible('fade-in');
			setTimeout( () => {
				setIsVisible('');
				setTimeout( () => {
					setIsVisible('fade-out');
				}, 1500);
				
			}, 500);
	}

	return (
	<div style={{margin: '0px 5%'}}>
		<Spacer />
		<BackButton />
		<Spacer />
		<div className='full-height flex-column-horizontal-center-only'>
			<div className='grid-column'>
				<h1 className='primary-title-center slide-in-horizontally'>{lang.loginMessage}</h1>
				<Spacer />
				<div className='center-flex animated-div'>
					<img className='logo-login' alt="logo" src={logo}/>
				</div>
			</div>
			<Spacer />
			<form className='login-form animated-div' onKeyDown={handleKeydown}>
				<input className='form-text-item' 
					type="text"
					placeholder={lang.email}
					onChange={handleChange}
					name="email"
					value={formData.email}
				/>
				<Spacer25 />

				<input className='form-text-item' 
					type="password"
					placeholder={lang.password}
					onChange={handleChange}
					name="password"
					value={formData.password}
				/>
				<Spacer25 />

				<input className='form-text-item' 
					type="password"
					placeholder={lang.confirmPassword}
					onChange={handleChange}
					name="confirmPassword"
					value={formData.confirmPassword}
				/>

				<Spacer />	

			<Button 
				onClick={(event) => handleSubmit(event)}
				variant="contained" 
				className='grow-and-shrink-slightly' 
				sx={{
					minHeight: 40,
					minWidth: 200,
					borderRadius: 5,
					padding: 2,
					fontSize: 20,
					textTransform: "none",
					fontFamily: "inherit",
					fontWeight: 400,
			}}>
				{lang.signUp}
			</Button>
				<Spacer25 />
				<div className={`${isVisible} little-popup alert`}>{alertString}</div>

			</form>
		</div>
	</div>
	);

}

export function ResetPasswordRedirect() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const oobCode = urlParams.get('code');
    
    if (oobCode) {
      // Redirect to Firebase's reset password page
      window.location.href = `https://app.continentalis.eu/reset-password/__/auth/actionoobCode=${oobCode}`;
    } else {
      // Handle invalid or missing code if needed
      alert("Invalid reset link.");
    }
  }, []);

  return (
    <div>
      <p>Redirecting...</p>
    </div>
  );
}
